import { Badge, Tooltip } from './PrimereactComponents';
import { formatMemberName } from '../utils/texts';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './AliasTooltip.css';

export const formatAliasInterval = (dateFrom, dateTo, t) => {
    if (dateFrom && dateTo) return ` (${dateFrom} - ${dateTo})`;
    else if (dateFrom) return ` (${t('intervalFrom', {ns: 'translation', datefrom: dateFrom})})`;
    else if (dateTo) return ` (${t('intervalUntil', {ns: 'translation', dateto: dateTo})})`;
    else return '';
};

export const AliasTooltip = ({ id, aliases }) => {
    const { t } = useTranslation();

    return (
        <>
            <Badge id={id} value={aliases.length} className='aliases-badge' />
            <Tooltip target={`#${id}`}>
                <div className='aliases-container'>
                    {aliases.map((a) => (
                        <span key={a.id}>
                            {formatMemberName(a.jmeno, a.prijmeni)}
                            {formatAliasInterval(a.datum_od, a.datum_do, t)}
                        </span>
                    ))}
                </div>
            </Tooltip>
        </>
    );
};
